import React, { Component } from 'react';

import DesignerBase from './designer-base/DesignerBase';

import Console from '../../lib/debug';

import * as CalendarState from '../../state/reducer/calendar/calendar';
import * as DesignerState from '../../state/reducer/designer/designer';
import * as ProgramTypes from '../../state/reducer/calendar/programTypes';

export default class ProgramDesignerView extends Component {
    constructor(props) {
        super(props);
        this.loadCalendarData(props);
    }

    componentDidUpdate() {
        this.loadCalendarData(this.props);
    }

    async loadCalendarData(props) {
        const programId = parseInt(props.match.params.programId);
        const dateData = {
            dayIndex: props.match.params.dayIndex,
            weekIndex: props.match.params.weekIndex
        };

        DesignerState.setInfo(ProgramTypes.TYPES.FIXED, props.match.params);
        CalendarState.loadProgram(programId, dateData);
    }

    render() {
        Console.render('ProgramDesignerView');
        return <DesignerBase />;
    }
}



// WEBPACK FOOTER //
// ./src/view/designer/ProgramDesignerView.jsx